export default {
  termOfServices:
    'https://app.termly.io/document/terms-of-use-for-website/9f396162-a1a3-4146-b8f9-144b5281a07a',
  privacyPolicy:
    'https://app.termly.io/document/privacy-policy/f7d10654-e2ed-4378-92de-b432ba693f26',
}
